import { render, staticRenderFns } from "./IndustryDetail.vue?vue&type=template&id=930b355c&"
import script from "./IndustryDetail.vue?vue&type=script&lang=js&"
export * from "./IndustryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports